export enum Actions {
    SET_INCOMPLETE_INFO_SCREENS = "SET_INCOMPLETE_INFO_SCREENS",
    REMOVE_COMPLETED_SUB_STATUS = "REMOVE_COMPLETED_SUB_STATUS",
    HIDE_TOAST = "HIDE_TOAST",
    SHOW_TOAST = "SHOW_TOAST",
    SET_BANK_STATEMENT_STATUS = "SET_BANK_STATEMENT_STATUS",
}

export const setIncompleteInfoScreens  = (screenInfo) => {
    return {type: Actions.SET_INCOMPLETE_INFO_SCREENS, body: screenInfo};
};

export const removeCompletedSubStatus = (screenName: string) => {
    return {type: Actions.REMOVE_COMPLETED_SUB_STATUS, body: screenName};
};

export const hideToast = () => ({type: Actions.HIDE_TOAST});

export const showToast = (bgColor: string, msg: string) => ({type: Actions.SHOW_TOAST, body: {bgColor, msg}});

export const setBankStatementStatus = (bankStatementStatus: {is_bs_upload_allowed: boolean}) =>
({type: Actions.SET_BANK_STATEMENT_STATUS, body: bankStatementStatus});
